import { getPromiseCallbacks } from '@egr/xbox/utils/promise/Callbacks';

export class AppInitialization {
    private callbacks = getPromiseCallbacks();
    private _initializationState: 'finished' | 'failed' | 'running' = 'running';
    public readonly resolve: (data: void) => void;
    public readonly done: Promise<void>;
    public get initializationState() {
        return this._initializationState;
    };

    constructor() {
        this.done = this.callbacks.promise;
        this.resolve = this.callbacks.resolve;
        void this.done
            .then(() => {
                this._initializationState = 'finished';
            })
            .catch((error) => {
                this._initializationState = 'failed';
                throw error;
            });
    }
}